<template>
  <div :class="{ 'c-dark-theme': $store.state.darkMode, animated: false, fadeIn: true }">
    <BCard>
      <BCard header-tag="header" footer-tag="footer" class="mb-1">
        <div slot="header">
          <BIconShieldLockFill/> <strong> 사용자 접근 화면 설정</strong>
          <div class="card-header-actions">
            <small class="text-muted">역할 및 사용자별 접근 화면을 관리합니다.</small>
          </div>
        </div>

        <BRow class="mb-2">
          <BCol>
            <BInputGroup>
              <BFormSelect size="sm" v-model="system" :options="systemOpts" required class="theme-select"/>
              <BInputGroupAppend>
                <BButton size="sm" variant="warning" @click="insertRecord">
                  <BIconPlusCircleFill/> 추가
                </BButton>
              </BInputGroupAppend>
            </BInputGroup>
          </BCol>
          <BCol>
            <BInputGroup size="sm" prepend="사용자그룹">
              <BFormSelect size="sm" v-model="role" @input="getAccessMapList" :options="rolesOpts" class="theme-select"/>
            </BInputGroup>
          </BCol>
          <BCol sm="4">
            <BInputGroup size="sm">
              <BInputGroupAppend>
                <BFormSelect size="sm" class="ml-3 theme-select" v-model="searchField" :options="searchOpts"/>
              </BInputGroupAppend>
              <BInputGroupAppend>
                <BFormInput size="sm" v-model="searchWord" type="text" @keyup.enter="getAccessMapList"/>
                <BButton size="sm" variant="info" @click="getAccessMapList">
                  <BIconSearch/> 검 색
                </BButton>
              </BInputGroupAppend>
            </BInputGroup>
          </BCol>
          <BCol sm="3" class="text-right">
            <BButtonGroup>
              <BButton size="sm" variant="primary" @click="getAccessMapList"><BIconArrowRepeat/></BButton>
              <BButton size="sm" variant="info" v-b-modal.download-modal class="ml-1"><BIconFileSpreadsheetFill/></BButton>
            </BButtonGroup>
          </BCol>
        </BRow>

        <BRow>
          <BCol>
            <vue-excel-editor
                v-model="rows"
                ref="excelGrid"
                width="100%"
                class="mb-1"
                :page="numOfRecord"
                :readonly-style="{backgroundColor:'#4F5040'}"
                @update="updateRecord"
                @select="selectRecord"
                :localized-label="excelEditorLabel"
                filter-row>
              <vue-excel-column field="_id" type="string" key-field invisible/>
              <vue-excel-column field="system" type="map" width="120px" label="시스템" :options="{'atg-manager': 'ATG매니저'}"/>
              <vue-excel-column field="path" type="map" width="300px" label="경로" :options="frontMap"/>
              <vue-excel-column field="role" type="map" width="120px" label="사용자 그룹" :options="rolesMap"/>
              <vue-excel-column field="user" type="map" width="200px" label="사용자" :options="userMap"/>
              <vue-excel-column field="acsType" type="map" width="100px" label="허용/거부" :options="acsTypeMap"/>
              <vue-excel-column field="regId" type="string" width="80px" label="생성자" readonly/>
              <vue-excel-column field="updId" type="string" width="80px" label="수정자" readonly/>
              <vue-excel-column field="createdAt" type="datetime" width="140px" label="등록일시" :to-text="toLocalTime" readonly/>
              <vue-excel-column field="updatedAt" type="datetime" width="140px" label="수정일시" :to-text="toLocalTime" readonly/>
            </vue-excel-editor>
          </BCol>
        </BRow>

        <BRow>
          <BCol>
            <BButtonGroup>
              <BButton variant="danger" class="ml-2" @click="deleteRecord">
                <BIconTrashFill/> 선택 정보삭제
              </BButton>
            </BButtonGroup>
          </BCol>
          <BCol>
            <BProgress height="2rem" :value="progCount" :max="totalCount" variant="warning" show-value/>
          </BCol>
        </BRow>
      </BCard>
    </BCard>

    <BModal ref="download-modal" id="download-modal" hide-footer header-bg-variant="warning" title="다운로드 사유 입력">
      <BFormInput v-model="downloadReason"></BFormInput>
      <b-button class="mt-3" variant="outline-danger" block @click="exportExcel"><BIconDownload/> 다운로드</b-button>
    </BModal>
  </div>
</template>

<script>
import '../../common/HelperMixin';
import {
  alertSync,
  alertConfirm,
  apiCall,
  cloneVar,
  toastSync,
  accessLogging
} from '../../common/utils';
import {ExcelEditorLabel} from '@/common/constants'

import qs from 'querystring';
import moment from "moment";
import {bizNo, email, name, phone} from "@/common/masking";

const columnMap = {
  system: '시스템',
  path: '경로',
  name: '경로명',
  acsType: '허용여부',
  role: '권한',
  user: '사용자',
  createdAt: '생성일시',
  updatedAt: '수정일시',
  logId: '생성자',
  updId: '수정자'
};

const _access_map = {
  system: '',
  path: '/',
  name: '',
  acsType: 'A',
  role: 'SM',
  user: ''
};

export default {
  name: "customer",
  data() {
    return {
      excelEditorLabel: ExcelEditorLabel,
      rolesMap: {
        "": '',
        "SA": '관리자',
        "SM": '담당자',
        "SS": '사용자',
      },
      rolesValueMap: {
        '담당자': "SM",
        '사용자': "SS",
      },
      acsTypeMap: {
        'A': "허용",
        'D': "거부",
      },
      userMap: {},
      frontMap: {},
      system: 'atg-manager',
      downloadReason: '',

      role: '',
      searchOpts: [
        { value: 'system', text: '시스템' },
        { value: 'path', text: '경로' },
      ],
      systemOpts: [
        { value: '', text: '시스템 선택' },
        { value: 'atg-manager', text: 'ATG 매니저' },
      ],
      acsTypeOpts: [
        { value: 'A', text: '허용' },
        { value: 'D', text: '거부' },
      ],
      rolesOpts: [
        { value: '', text: '전체 그룹' },
        { value: 'SM', text: '담당자 그룹' },
        { value: 'SS', text: '사용자 그룹' },
      ],

      progCount: 0,
      totalCount: 0,

      rows: [],
      claimLogs: [],
      selectedIdx: null,
      selectedRow: null,

      searchWord: null,
      searchField: 'path',
      paramMap: {},

      numOfRecord: 20,
    };
  },

  async created() {
    try {
      await this.getUserMap();
      await this.getFrontMap();
      await this.getAccessMapList();
    } catch (err) {
      console.log(err);
    }
  },

  methods: {
    async getUserMap() {
      try {
        const rs = await apiCall('get', `/api/user/list`);
        this.userMap[''] = '사용자 전체';
        for (const r of rs.result) {
          this.userMap[r.userId] = `[${r.userId}] ${r.name}-${this.rolesMap[r.role]}-${r.role}`;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getFrontMap() {
      try {
        const rs = await apiCall('get', `/api/access/path`);
        for (const r of rs.result.result) {
          this.frontMap[r.path] = r.path;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getAccessMapList() {
      let r = null;
      let qry = '';
      this.paramMap = {};
      if (this.role) this.paramMap = { role: this.role };
      if (this.searchWord) this.paramMap[this.searchField] = this.searchWord;
      qry = qs.stringify(this.paramMap);
      console.log("query-string ---------- ", qry);
      try {
        this.rows = [];
        r = await apiCall('get', `/api/access/map/query?${qry}`);
        console.log('accessMap query result --->', r);
        if (r.result) {
          this.rows = r.result;
          await toastSync(this.$bvToast, `${this.rows.length}건 조회됨`, 'primary');
        }
      } catch (err) {
        console.log(err);
      }
    },

    async exportExcel() {
      try {
        if (!this.downloadReason || this.downloadReason.length < 5) {
          return await toastSync(this.$bvToast, "[사유 없음] 다운로드 사유는 5자 이상 입력해야 합니다.", 'danger');
        }

        const numRecs = this.$refs['excelGrid'].getSelectedRecords().length;

        if (!numRecs) {
          this.$refs['download-modal'].hide();
          return await toastSync(this.$bvToast, "[선택 레코드 없음] 선택한 레코드만 파일로 생성됩니다.", 'danger');
        }
        const { currentRoute } = this.$router;
        const { fields } = this.$refs["excelGrid"];
        const format = 'xlsx';
        const exportSelectedOnly = true;

        const filename = currentRoute.path.split('/').pop() + '-' + moment().format('YYYY-MM-DD');
        const labels = fields.map(i => { return i.label });
        const rs = await accessLogging(
          'download',
          currentRoute,
          labels,
          this.downloadReason,
          `레코드수: ${numRecs}, 파일명: ${filename}.${format}`
        );
        if (rs === true) {
          this.$refs["excelGrid"].exportTable(format, exportSelectedOnly, filename);
          this.downloadReason = '';
          return true;
        } else {
          await toastSync(this.$bvToast, "Error: " + rs.message, 'danger');
          return false;
        }
      } catch (err) {
        console.log('exportExcel error', err);
      } finally {
        this.$refs['download-modal'].hide();
      }
    },

    async selectRecord(idx, evt) {
      if (!evt) return;
    },

    async insertRecord() {
      if (!this.system) return;
      let r = null;
      let rec = cloneVar(_access_map);
      rec.role = this.role ? this.role : 'SS';
      rec.system = this.system;
      try {
        r = await apiCall('POST', `/api/access/map`, rec);
        if (r.code === 200) {
          await this.getAccessMapList();
        }
        await this.toastResult(r, '접근 설정 등록');
      } catch (err) {
        console.log(err);
      }
    },

    async updateRecord(recs) {
      let rc = recs[0];
      if (!rc.keys[0]) {
        console.log("nokey");
        return;
      }

      let r = null;
      let param = {};
      const objectId = rc.keys[0];
      const fieldName = rc.name;
      param[fieldName] = rc.newVal;
      try {
        if (fieldName === 'user') {
          let userTexts = this.userMap[rc.newVal].split('-');
          param['role'] = userTexts.pop();
        }

        console.log('param:', param);

        r = await apiCall("PUT", `/api/access/map/${objectId}`, param);
        console.log('result:', r);
        if (r.code === 200) {
          await toastSync(this.$bvToast, `${columnMap[fieldName]} 수정됨`, 'warning');
        } else {
          await toastSync(this.$bvToast, `${columnMap[fieldName]} 수정 에러: ${r.message}`);
        }
      } catch (err) {
        await toastSync(this.$bvToast, `${columnMap[fieldName]} 수정 에러: ${err.message}`);
        console.log(err);
      }
    },

    async deleteRecord() {
      try {
        let params = this.$refs['excelGrid'].getSelectedRecords();
        this.progCount = 0;
        this.totalCount = params.length;
        if (!params.length) return alert('[선택된 레코드 없음] 좌측의 번호를 클릭하여 레코드를 선택');
        console.log("deleteRecord ----> ", params);
        console.log("deleteRecord length ----> ", params.length);

        const confirmMsg = `${params.length} 개의 데이터를 삭제 합니다. 삭제된 데이터는 복구할 수 없으며 시스템 장애가 발생할 수 있습니다. 진행 하시겠습니까?`;

        if (!(await alertConfirm(this.$bvModal, confirmMsg, '레코드 삭제'))) {
          return;
        }

        let failCnt = 0;
        for (let record of params) {
          const tIndex = this.$refs['excelGrid'].rowIndex[record.$id];
          const r = await apiCall('DEL', `/api/access/map/${record._id}`);
          if (r.code === 200) {
            this.progCount++;
            this.$refs["excelGrid"].deleteRecord(tIndex);
          }
        }

        await alertSync(this.$bvModal, { text: `삭제: ${this.progCount}건, 실패: ${failCnt}` });
        this.$refs['excelGrid'].clearAllSelected();
        await this.getAccessMapList();
      } catch (err) {
        console.log(err);
      }
    },

    toName(val) { return name(val) },
    toPhone(val) { return phone(val) },
    toEmail(val) { return email(val) },
    toBizNo(val) { return bizNo(val) },
    toRolesValue(val) { return this.rolesValueMap[val].split(','); },
    toRolesText(val) { return this.rolesMap[val] },
    toArrayText(val) { return val ? val.toString() : ''; },
    toArrayVal(val) {
      try {
        if (val) val = val.replace(/\s/g, '');
        return val ? val.split(',') : [];
      } catch (err) {
        return [];
      }
    },
    toLocalTime(val) {
      return moment(val).format("YYYY-MM-DD HH:mm")
    },
    toIsoTime(val) {
      return moment(val, 'YYYY-MM-DD HH:mm').toISOString()
    },
  }
}
</script>
